const usePaths = location => {
    const rootPath = `${__PATH_PREFIX__}/`

    return {
        rootPath,
        isRootPath: location.pathname === rootPath
    }
}

export default usePaths